export default "__VITE_ASSET__B$NCZanN__"